import { useEffect, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { H4, H5, H3 } from "../components/Typography";
import { FC } from "react";
import FormatCurrency from "../constants/formateCurrency";
import { API_BASE_URL } from "../Api/EndPoints";
import { load } from "../constants/storage";
import * as Models from "../models";
import { toast } from "react-hot-toast";
import { useAppDispatch } from "../store/hooks";
import { getFundisin } from "../redux/actions/PortfolioAction";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SIPdateModel from "../components/SIPdateModel";
import { useNavigate } from "react-router-dom";

// root component interface
interface CardProps {
  data: any;
  onPressMore?: any;
  onPressInvest?: any;
  onPressRedeem?: any;
  onpressProceedInvest?: any;
  onpressProceedRedeem?: any;
  onPressCross?: any;
  moreValue?: any;
  investvalue?: any;
  redeemvalue?: any;
  defaultValue?: any;
  index?: number;
}

const MyHoldingCard: FC<CardProps> = ({
  data,
  onPressMore,
  onPressInvest,
  onPressRedeem,
  onPressCross,
  onpressProceedInvest,
  onpressProceedRedeem,
  moreValue,
  investvalue,
  redeemvalue,
  defaultValue,
  index,
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    getFundSipDetail();
  }, []);

  // Redeem
  const [redeemAllValue, setRedeemAllValue] = useState<boolean>(false);
  const [unitsToRedeem, setUnitsToRedeem] = useState("");

  //Invest filed
  const [textField1Focus, setTextField1Focus] = useState(false);
  const [textField2Focus, setTextField2Focus] = useState(false);

  //fund sip
  const [fundDetails, setFundDetails] = useState<string>("");
  const [investedAmount, setInvestedAmount] = useState<string>("");
  const [investedSipAmount, setInvestedSipAmount] = useState<string>("");
  const [minSipAmount, setMinSipAmount] = useState<string>("");
  const [maxSipAmount, setMaxSipAmount] = useState<string>("");

  //One Time
  const [additinalInvestedAmount, setAdditionalInvestedAmount] =
    useState<string>("");
  const [additinalMinAmount, setAdditionalMinAmount] = useState<string>("");
  const [additinalMaxAmount, setAdditionalMaxAmount] = useState<string>("");

  // Sip Button
  const [selectedDate, setSelectedDate] = useState("");
  const [sipDateList, setDateList] = useState();
  const [sipLastDate, setSipLastDate] = useState();

  let navigate = useNavigate();

  const handleChange = (event: any) => {
    const numericValue = event.target.value.replace(/\D/g, ""); // Remove non-digit characters

    setUnitsToRedeem(numericValue);
    if (numericValue !== "") {
      setRedeemAllValue(false); // Uncheck checkbox when text field has a value
    }
  };

  const handleRadioChange = (event: any) => {
    setRedeemAllValue(event.target.checked);
    if (event.target.checked) {
      setUnitsToRedeem(""); // Clear text field value when checkbox is selected
    }
  };
  const onEmptyPress = () => {
    toast.error("You don't have any redeemable units");
  };

  const getImgUrl = (pic: string) => {
    pic = pic.toString().slice(1);
    if (pic) {
      return API_BASE_URL + pic;
    }
    return "";
  };

  const onProcessRedeem = () => {
    if (!redeemAllValue && unitsToRedeem === "") {
      toast.error("Please select one option");
      return;
    }
    onpressProceedRedeem("Redeem", redeemAllValue, data, unitsToRedeem);
  };

  const handleTextField1Focus = () => {
    setTextField1Focus(true);
    setTextField2Focus(false);
    if (investedAmount) {
      setInvestedAmount("");
    }
  };

  const handleTextField2Focus = () => {
    setSelectedDate("");
    setTextField2Focus(true);
    setTextField1Focus(false);
    if (investedSipAmount) {
      setInvestedSipAmount("");
    }
  };

  const handleTextField1Change = (event: any) => {
    setInvestedSipAmount(event.target.value);
  };

  const handleTextField2Change = (event: any) => {
    setInvestedAmount(event.target.value);
  };

  // data
  const getFundSipDetail = async () => {
    // setLoading(true);
    let token = load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const req: Models.MutualFundsDetailRequest = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
      isin: data.schemes[0]?.isin,
    };

    dispatch(getFundisin(req, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        console.log("-----------dedeedwedew", response);
        setFundDetails(response?.holdings ?? "");
        //sip
        setMinSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.min_installment_amount
        );
        setMaxSipAmount(
          response?.holdings?.sip_frequency_specific_data?.monthly
            ?.max_installment_amount
        );

        //additional Buy fund
        setAdditionalInvestedAmount(
          response?.holdings.min_additional_investment ?? ""
        );
        setAdditionalMinAmount(
          response?.holdings?.min_additional_investment ?? ""
        );
        setAdditionalMaxAmount(
          response?.holdings?.max_additional_investment ?? ""
        );
        if (response?.holdings?.sip_frequency_data) {
          const dateListString =
            response?.holdings?.sip_frequency_data["MONTHLY"];
          const dateList = dateListString.split(",");
          setDateList(dateList);
          setSipLastDate(
            dateList?.length > 0 ? dateList[dateList?.length - 1] : ""
          );
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  //sipdate model
  const [sipdateModel, setSipDateModel] = useState(false);

  const handlesipOpenModal = () => {
    setSipDateModel(true);
  };
  const handlesipCloseModal = () => {
    setSipDateModel(false);
  };

  const handleSaveSipDateModel = (value: any) => {
    setSelectedDate(value);
    handlesipCloseModal();
  };

  const dateOrdinal = (d: any) => {
    return (
      d +
      (31 == d || 21 == d || 1 == d
        ? "st"
        : 22 == d || 2 == d
        ? "nd"
        : 23 == d || 3 == d
        ? "rd"
        : "th")
    );
  };

  const onhandleInvest = () => {
    if (!investedAmount && !investedSipAmount) {
      toast.error("Please enter a detail");
      return;
    }
    if (investedSipAmount) {
      if (!selectedDate) {
        toast.error("Please select SIP date");
        return;
      }
      if (investedSipAmount < minSipAmount) {
        toast.error(`Minimum sip amount is Rs.${minSipAmount}`);
        return;
      }
      if (investedSipAmount > maxSipAmount) {
        toast.error(`Sip amount is cannot be greater than Rs.${maxSipAmount}`);
        return;
      }
      onpressProceedInvest("Sip", investedSipAmount, selectedDate, data);
    }
    if (investedAmount) {
      if (investedAmount < additinalMinAmount) {
        toast.error(
          `Minimum additional investment amount is Rs.${additinalMinAmount}`
        );
        return;
      }
      if (investedAmount > additinalMaxAmount) {
        toast.error(
          `Maximum additional investment amount is Rs.${additinalMaxAmount}`
        );
        return;
      }
      onpressProceedInvest("additional", investedAmount, "", data);
    }
  };

  return (
    <>
      {investvalue ? (
        <Grid xs={15} md={5} sx={sxStyleBox}>
          <Grid
            alignSelf="flex-end"
            justifyContent="flex-end"
            alignItems="flex-end"
            display="flex"
            onClick={onPressCross}
          >
            <Box
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/crossIcon.svg"
              sx={sxStyleImageCross}
            />
          </Grid>
          <Grid>
            <Box
              sx={{
                display: "flex",
                p: { xs: 1, sm: 1, md: 1 },
                marginTop: { xs: 0, sm: 0, md: -1 },
              }}
            >
              <Box
                component="img"
                src={getImgUrl(data?.schemes[0].logo)}
                sx={sxStyleImage}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginLeft: 1.5,
                }}
              >
                <H4 color="#000000" sx={text}>
                  {data?.schemes[0]?.name}
                </H4>
                <H4 fontWeight={500} sx={{ mt: 1 }}>
                  SIP
                </H4>

                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TextField
                    name="sip"
                    placeholder={"Min. SIP Amount " + minSipAmount}
                    sx={{
                      "::placeholder": {
                        fontSize: 12,
                        color: "red !important",
                      },
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "94%",
                      },
                      marginTop: {
                        xs: 0.5,
                        sm: 2,
                        md: 0.5,
                      },
                      padding: 0.1,
                    }}
                    InputProps={{
                      style: {
                        height: "35px",
                        width: "100%",
                      },
                    }}
                    onFocus={handleTextField1Focus}
                    onBlur={() => setTextField1Focus(false)}
                    disabled={textField2Focus}
                    value={investedSipAmount}
                    onChange={handleTextField1Change}
                  />
                  <CalendarMonthIcon
                    onClick={() => handlesipOpenModal()}
                    style={{
                      color: "#012876",
                      fontSize: "1.3rem",
                      marginRight: 5,
                    }}
                  />
                </Grid>
                {(textField1Focus || investedSipAmount) && (
                  <H5
                    fontWeight={"400"}
                    fontSize={12}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "#000000",
                      flexDirection: "row",
                      marginRight: 1,
                    }}
                  >
                    {` ${
                      selectedDate == ""
                        ? "Please select installment date"
                        : `${dateOrdinal(selectedDate)} of every month`
                    } `}
                  </H5>
                )}

                <H4 fontWeight={500} sx={{ mt: 2 }}>
                  One Time
                </H4>

                <TextField
                  name="additinal"
                  placeholder={"Min. Amount " + additinalInvestedAmount}
                  sx={textInputStyles}
                  InputProps={{
                    style: {
                      height: "35px", // change this value to set the desired height
                    },
                  }}
                  onFocus={handleTextField2Focus}
                  onBlur={() => {
                    setTextField2Focus(false);
                    setSelectedDate("");
                  }}
                  disabled={textField1Focus}
                  value={investedAmount}
                  onChange={handleTextField2Change}
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            justifyContent="center"
            alignItems="center"
            onClick={onhandleInvest}
            sx={{
              mt: 1,
              display: "flex",
              p: 2,
              background: "#016AD6",
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            <Grid textAlign="center" sx={sxStylebuttonProceed}>
              Proceed
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      <SIPdateModel
        open={sipdateModel}
        handleClose={handlesipCloseModal}
        handleSave={handleSaveSipDateModel}
        sipList={sipDateList || []} // add a default empty array if sipDateList is undefined
      />
      {redeemvalue ? (
        <Grid xs={15} md={5} sx={sxStyleBox}>
          <Grid
            alignSelf="flex-end"
            justifyContent="flex-end"
            alignItems="flex-end"
            display="flex"
            onClick={onPressCross}
          >
            <Box
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/crossIcon.svg"
              sx={sxStyleImageCross}
            />
          </Grid>

          <Grid>
            <Box
              sx={{
                display: "flex",
                p: { xs: 1, sm: 1, md: 1 },
                marginTop: { xs: 0, sm: 0, md: -1 },
              }}
            >
              <Box
                component="img"
                src={getImgUrl(data?.schemes[0].logo)}
                sx={sxStyleImage}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  marginLeft: 1.5,
                }}
              >
                <H4 color="#000000" sx={text}>
                  {data?.schemes[0]?.name}
                </H4>
                <H4 color={"#868686"} fontSize={14} sx={{ mt: 0 }}>
                  {data?.schemes[0].holdings.units} units available
                </H4>
                <H4 color={"#868686"} fontSize={14} sx={{ mt: 0 }}>
                  {data?.schemes[0].holdings.redeemable_units} Redeemable units
                </H4>

                <TextField
                  disabled={redeemAllValue}
                  name="amount"
                  placeholder="Enter Units"
                  sx={textInputStyles}
                  InputProps={{
                    style: {
                      height: "35px", // change this value to set the desired height
                    },
                  }}
                  onChange={handleChange}
                  value={unitsToRedeem}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
                <Grid display="flex">
                  <H3 fontSize={16} fontWeight={500} sx={{ mt: 1 }}>
                    Or{" "}
                  </H3>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={redeemAllValue}
                        onChange={handleRadioChange}
                        color="primary"
                        sx={{ ml: 1 }}
                      />
                    }
                    label="Redeem All"
                  />
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid
            justifyContent="center"
            alignItems="center"
            onClick={onProcessRedeem}
            sx={{
              mt: 1,
              display: "flex",
              p: 2,
              background: "#016AD6",
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            <Grid
              onClick={onpressProceedRedeem}
              textAlign="center"
              sx={sxStylebuttonProceed}
            >
              Proceed
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      {defaultValue ? (
        <Grid
          xs={15}
          md={5}
          // onClick={() => {
          //   navigate("/funddetails", {
          //     state: {
          //       data: fundDetails,
          //       customer: null,
          //       goalData: null,
          //     },
          //   });
          // }}
          sx={sxStyleBox}
        >
          <Box
            sx={{
              display: "flex",
              p: { xs: 1, sm: 1, md: 2 },
            }}
          >
            <Box
              component="img"
              src={getImgUrl(data?.schemes[0].logo)}
              sx={sxStyleImage}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginLeft: 1.5,
              }}
            >
              <H4 color="#000000" sx={text}>
                {data?.schemes[0]?.name}
              </H4>

              <H4 fontSize={14} color={"#868686"}>
                Folio Number: {data?.folio_number}
              </H4>
              <Grid justifyContent="space-between" sx={{ display: "flex" }}>
                <H4 color={"#868686"} fontSize={14}>
                  {data?.schemes[0].holdings.units} Units
                </H4>
                <H4 color={"#868686"} fontSize={14}>
                  NAV: {data?.schemes[0].nav.value}
                </H4>
              </Grid>
            </Box>
          </Box>
          <Grid
            sx={{
              display: "flex",
              mt: 0,
              background: "#FEF7E3",
            }}
          >
            <Grid
              sx={{
                width: "33.3%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                pt: 2,
                pb: 2,
              }}
            >
              <H4
                fontSize={14}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                }}
                color={"#868686"}
              >
                Current Value
              </H4>
              <H4
                sx={{
                  width: "100%",
                  textAlign: "center",
                }}
                fontWeight={"600"}
              >
                ₹{data?.schemes[0].market_value.amount}
              </H4>
            </Grid>
            <Grid
              sx={{
                width: "33.3%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                pt: 2,
                pb: 2,
              }}
            >
              <H4
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                }}
                color={"#868686"}
                fontSize={14}
              >
                Invested
              </H4>
              <H4
                sx={{
                  width: "100%",
                  textAlign: "center",
                }}
                fontWeight={"600"}
              >
                ₹{data?.schemes[0]?.invested_value.amount}
              </H4>
            </Grid>
            <Grid
              sx={{
                width: "33.3%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <H4
                fontSize={14}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                }}
                color={"#868686"}
              >
                Gain/Loss
              </H4>
              <H4
                sx={{
                  width: "100%",
                  textAlign: "center",
                  color:
                    data?.schemes[0]?.market_value?.amount -
                      data?.schemes[0]?.invested_value?.amount <
                    0
                      ? "#f00"
                      : "#518203",
                }}
                fontWeight={"600"}
              >
                ₹
                {data?.schemes[0]?.market_value?.amount -
                  data?.schemes[0]?.invested_value?.amount <
                0
                  ? "-"
                  : null}
                {FormatCurrency(
                  (
                    data?.schemes[0]?.market_value?.amount -
                    data?.schemes[0]?.invested_value?.amount
                  )?.toFixed(2) ?? "0.00"
                )}
              </H4>
            </Grid>
          </Grid>

          {moreValue ? (
            <Grid
              justifyContent="center"
              alignItems="center"
              sx={{
                display: "flex",
                mt: 2,
              }}
            >
              <Grid
                onClick={onPressInvest}
                textAlign="center"
                sx={{
                  borderBottomLeftRadius: 8,
                  p: 2,
                  background: "#016AD6",
                  color: "#fff",
                  width: "50%",
                  borderRight: "1px solid #000000",
                }}
              >
                Invest More
              </Grid>
              <Grid
                onClick={
                  data?.schemes[0].holdings.redeemable_units === 0
                    ? onEmptyPress
                    : onPressRedeem
                }
                textAlign="center"
                sx={{
                  borderBottomRightRadius: 8,
                  p: 2,
                  background:
                    data?.schemes[0].holdings.redeemable_units === 0
                      ? "#bbb"
                      : "#016AD6",
                  color: "#fff",
                  width: "50%",
                }}
              >
                Redeem
              </Grid>
            </Grid>
          ) : (
            <Grid
              justifyContent="center"
              alignItems="center"
              sx={{ p: 2, display: "flex" }}
              onClick={onPressMore}
            >
              <Box
                component="img"
                sx={{
                  height: 10,
                  minwidth: {
                    md: 10,
                    xs: 10,
                    sm: 10,
                  },
                  mr: 1,
                }}
                src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/down-arrow.svg"
                alt="saas-dasboard-footer"
              />
              <H5 color="#016AD6" fontWeight={"500"}>
                More Options
              </H5>
            </Grid>
          )}
        </Grid>
      ) : null}
    </>
  );
};

export default MyHoldingCard;
const sxStyleImage = {
  height: {
    xs: 30,
    sm: 30,
    md: 50,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
  m: 0.6,
  mb: 0,
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.1,
};
const sxStyleImageCross = {
  p: 0.4,
  border: 1,
  borderColor: "#FF0000",
  borderRadius: 5,
  position: "relative",
  top: -6,
  right: -6,
  height: {
    xs: 15,
    sm: 15,
    md: 15,
  },
  minwidth: {
    xs: 30,
    sm: 30,
    md: 30,
  },
};

const sxStylebuttonProceed = {
  color: "#fff",
};
const text = {
  fontFamily: "'Poppins', sans-serif",
  display: "flex",
  fontSize: 15,
  mt: 0.13,
  fontWeight: "500",
};

const sxStyleBox = {
  background: "#fff",
  borderRadius: 4,
  justifyContent: "space-between",
  display: "flex",
  flexDirection: "column",
  mt: {
    md: 1,
    xs: 2,
    sm: 1,
  },
  border: "0.5px solid rgba(219, 219, 219, 1)",
  ml: 3,
  // background:'#f00'
};
